import { useCallback, useEffect, useRef, useState } from "react";
import { isRequestCancellation } from "@shared/api/client";
import { getRrhhData } from "../api/rrhh";
import type { RrhhData } from "../types/rrhh";

const emptyData: RrhhData = {
  clock: {
    status: "sin_entrada",
    seconds: 0,
    entry_time: null,
    exit_time: null,
    today: new Date().toISOString().slice(0, 10),
    schedule: null,
  },
  vacations: {
    items: [],
    summary: {
      annual_days: 23,
      carry_days: 0,
      carry_locked: false,
      carry_origin_year: new Date().getFullYear() - 1,
      carry_deadline: `${new Date().getFullYear()}-03-31`,
      current_used_days: 0,
      carry_used_days: 0,
      used_days: 0,
      remaining_current_days: 23,
      remaining_carry_days: 0,
      remaining_days: 23,
      half_days_used: 0,
      half_days_remaining: 4,
      max_half_days: 4,
    },
    calendar_days: [],
    constraints: {
      today: new Date().toISOString().slice(0, 10),
      selectable_until: `${new Date().getFullYear()}-12-31`,
      carry_deadline: `${new Date().getFullYear()}-03-31`,
      carry_locked: false,
      max_half_days: 4,
    },
  },
  payrolls: [],
  contracts: [],
};

export function useRrhh() {
  const [data, setData] = useState<RrhhData>(emptyData);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  const reload = useCallback(async () => {
    setLoading(true);

    try {
      const rrhh = await getRrhhData();

      if (!mountedRef.current) return;

      setData(rrhh);
    } catch (error) {
      if (!isRequestCancellation(error)) {
        console.error("Error cargando RRHH", error);
      }
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    void reload();

    return () => {
      mountedRef.current = false;
    };
  }, [reload]);

  return {
    data,
    loading,
    reload,
  };
}
